import React, { Component } from 'react';
import { Row, Col, Container } from "react-bootstrap";
import Mailchimp from 'react-mailchimp-form';

class NewsletterForm extends Component {
	render() {
		return (
			<div className="py-5 newsletter-signup">
                <Container>
                    <Row>
                    <Col><h4 className="text-center mb-4">Subscribe to Bridge Newsletter for latest product & news updates</h4></Col>
                    </Row>
                    <Row>
                        <Col sm={{ span: 4, offset: 4 }}>
                        <Mailchimp
                            //action='https://bridgealliance.us3.list-manage.com/subscribe/post?u=938c8fba7dcaf3cf1f5a89bd3&id=efb0c8bc02'     //Code Commeted for New MailChimp account
                            action='https://bridgealliance.us19.list-manage.com/subscribe/post?u=e464dec8649487268bfb88b25&amp;id=e074ffa1e2'  //Code Added for New MailChimp account
                            fields={[
                                {
                                    name: 'FNAME',
                                    placeholder: 'Name',
                                    type: 'text',
                                    required: true,
                                },
                                {
                                    name: 'EMAIL',
                                    placeholder: 'Email Address',
                                    type: 'email',
                                    required: true
                                }
                            ]}

                            messages = {
                                {
                                sending: "Sending...",
                                success: "Thank you for subscribing!",
                                error: "An unexpected internal error has occurred.",
                                empty: "You must write an e-mail.",
                                duplicate: "Too many subscribe attempts for this email address",
                                button: "Subscribe!"
                                }
                            }                
                            />
                        </Col>
                    </Row>
                </Container>
			</div>
		)
	}
}

export default NewsletterForm